__turbopack_context__.v({
  "counter": "Directions-module-scss-module__nQ-9cG__counter",
  "directions": "Directions-module-scss-module__nQ-9cG__directions",
  "directionsHeadline": "Directions-module-scss-module__nQ-9cG__directionsHeadline",
  "directionsName": "Directions-module-scss-module__nQ-9cG__directionsName",
  "fraction": "Directions-module-scss-module__nQ-9cG__fraction",
  "hasTillaTip": "Directions-module-scss-module__nQ-9cG__hasTillaTip",
  "list": "Directions-module-scss-module__nQ-9cG__list",
  "listItem": "Directions-module-scss-module__nQ-9cG__listItem",
  "paragraph": "Directions-module-scss-module__nQ-9cG__paragraph",
});
